module.exports = __webpack_public_path__ + "static/img/banner1.6a874d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banner1.png
// module id = cO9t
// module chunks = 1